export default "__VITE_ASSET__8x0N0d$K__"